import { observable, makeObservable } from 'mobx';

class WriteReviewConfig {
  form = {
    fields: {
      overallRating: {
        value: '',
        name: 'overallRating',
        rule: 'required',
        error: null,
        errorFlag: true,
      },
      
      recommend: {
        value: '',
        name: 'recommend',
        rule: 'required',
        errorFlag: true,
      },
      summary: {
        value: '',
        error: null,
        type: 'text',
        rule: ['required', 'between:1,50'],
        errorFlag: true,
      },
      description: {
        value: '',
        name: 'description',
        error: null,
        type: 'textarea',
        rule: ['required', 'between:50,500'],
        errorFlag: true,
      },
      nickname: {
        value: '',
        name: 'nickname',
        error: null,
        type: 'text',
        rule: ['required', 'between:4,25', 'regex:/^[a-zA-Z0-9_-]+$/'],
        errorFlag: true,
      },
      
      hairType: {
        value: '',
        name: 'hairType',
        error: null,
        rule: 'required',
        options: {
          validateOnChange: true,
        },
        errorFlag: true,
      },
      hairLength: {
        value: '',
        name: 'hairLength',
        error: null,
        options: {
          validateOnChange: true,
        },
        errorFlag: true,
      },
      hairNeed: {
        value: '',
        name: 'hairNeed',
        error: null,
        options: {
          validateOnChange: true,
        },
        errorFlag: true,
      },
      dobMonth: {
        value: '',
        name: 'dobMonth',
        error: null,
        rule: 'required',
        options: {
          validateOnChange: true,
        },
        errorFlag: true,
      },
      dobYear: {
        value: '',
        name: 'dobYear',
        error: null,
        rule: 'required',
        options: {
          validateOnChange: true,
        },
        errorFlag: true,
      },
      email: {
        value: '',
        name: 'email',
        error: null,
        type: 'text',
        rule: [
          'required',
          'regex:^[a-zA-Z0-9_-]+(?:.[a-zA-Z0-9_-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?$',
        ],
        errorFlag: true,
      },
      terms: {
        value: '',
        name: 'terms',
        type: 'checkbox',
        rule: 'required',
        options: {
          validateOnChange: true,
        },
        errorFlag: true,
      },
      preview: {
        name: 'preview',
        type: 'hidden',
        value: false,
        options: {
          validateOnChange: true,
        },
      },
      thankyou: {
        name: 'thankyou',
        type: 'hidden',
        value: false,
        options: {
          validateOnChange: true,
        },
      },
      sorryModal: {
        name: 'sorryModal',
        type: 'hidden',
        value: false,
        options: {
          validateOnChange: true,
        },
      },
      isSubmit: {
        name: 'isSubmit',
        type: 'hidden',
        value: false,
        options: {
          validateOnChange: true,
        },
      },
      locale: {
        name: 'locale',
        type: 'hidden',
        value: false,
        options: {
          validateOnChange: true,
        },
      },
      productID: {
        name: 'productID',
        type: 'hidden',
        value: false,
        options: {
          validateOnChange: true,
        },
      },
      errorLength: {
        name: 'errorLength',
        type: 'hidden',
        value: 0,
        options: {
          validateOnChange: true,
        },
      },
      serverErrorFlag: {
        name: 'serverErrorFlag',
        type: 'hidden',
        value: false,
        options: {
          validateOnChange: true,
        },
      },
      serverError: {
        name: 'serverError',
        type: 'hidden',
        value: 'ageCriteriaError',
        options: {
          validateOnChange: true,
        },
      },
    },
    error: {
      updateError: '',
      validationError: '',
    },
    success: false,
  };

  constructor() {
    makeObservable(this, {
      form: observable
    });
  }
}

const writeReviewConfig = new WriteReviewConfig();
export default writeReviewConfig;
